import type { NBAItem } from "../types";
import styles from "./ActionItem.module.css";

interface ActionItemProps {
  readonly action: NBAItem;
  readonly onToggle: () => void;
  readonly onExecuteAction?: (action: NBAItem, responseType?: string) => void;
}

function getDotClass(priority: string): string {
  if (priority === "high") return styles.dotHi ?? "";
  if (priority === "medium") return styles.dotMed ?? "";
  return styles.dotLo ?? "";
}

function getActionButtons(
  action: NBAItem,
  onExecute: (action: NBAItem, responseType?: string) => void,
): React.ReactNode {
  switch (action.action_type) {
    case "book_meeting":
      return (
        <div className={styles.actions}>
          <button type="button" className={styles.actionBtn} onClick={() => onExecute(action)}>Book Meeting</button>
        </div>
      );
    case "respond_meeting":
      return (
        <div className={styles.actions}>
          <button type="button" className={`${styles.actionBtn} ${styles.actionBtnAccept}`} onClick={() => onExecute(action, "accept")}>Accept</button>
          <button type="button" className={styles.actionBtn} onClick={() => onExecute(action, "tentativelyAccept")}>Tentative</button>
          <button type="button" className={`${styles.actionBtn} ${styles.actionBtnDecline}`} onClick={() => onExecute(action, "decline")}>Decline</button>
        </div>
      );
    case "resolve_conflict":
      return (
        <div className={styles.actions}>
          <button type="button" className={styles.actionBtn} onClick={() => onExecute(action)}>Resolve</button>
        </div>
      );
    default:
      return null;
  }
}

export function ActionItem({ action, onToggle, onExecuteAction }: Readonly<ActionItemProps>) {
  const pct = Math.round(action.confidence * 100);
  const dotClass = getDotClass(action.priority);
  const hasActionButtons = onExecuteAction && action.action_type && !action.is_completed;

  return (
    <div className={`${styles.actionItem} ${action.is_completed ? styles.done : ""}`}>
      <input type="checkbox" className={styles.checkbox} checked={action.is_completed} onChange={onToggle} />
      <div className={styles.body}>
        <span className={styles.label}>{action.title}</span>
        <span className={styles.meta}>
          <span className={`${styles.dot} ${dotClass}`} />
          <span className={styles.service}>{action.service}</span>
          <span className={styles.confidence}>{pct}%</span>
        </span>
        {hasActionButtons && getActionButtons(action, onExecuteAction)}
      </div>
    </div>
  );
}
